<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="addline-dialog"
  >
    <Form
      ref="form"
      @submit="submitHandle"
    ></Form>
  </sliderBarDialogShell>
</template>

<script>
import { saveLineConfig } from "@/api/sys/robitConfig/line";
import Form from '@/components/sys/robitCofig/line/Form'

export default {
  name: 'add',
  components:{
    Form,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      title: '新增line推送渠道',
    }
  },
  computed: {
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
      let params = {
        channelId: formData.channelId,
        channelName: formData.channelName,
        accessToken: formData.accessToken,
        channelSecret: formData.channelSecret,
        remark: formData.remark,
        status: formData.status
      }
      saveLineConfig(params).then((res) => {
        this.$refs.form.$refs.form.clearValidate();
        this.$refs.form.$refs.form.resetFields();

        this.$emit('add-success');
        this.$refs.form.reset();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
<style lang="scss">
@media screen and (min-width: 768px) {
  .addline-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}

</style>

